import type { FileResult } from '@/types';

const getFile = async (browserFile: File): Promise<FileResult> => {
  const [file, file_base64] = await Promise.all([
    new Promise<ArrayBuffer>((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => {
        resolve(fr.result as ArrayBuffer);
      };
      fr.onerror = reject;
      fr.readAsArrayBuffer(browserFile);
    }),
    new Promise<string>((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => {
        resolve(fr.result as string);
      };
      fr.onerror = reject;
      fr.readAsDataURL(browserFile);
    }),
  ]);
  return {
    name: browserFile.name,
    type: browserFile.type,
    contents: new Uint8Array(file),
    base64contents: file_base64,
  };
};

export default getFile;

